import { Formik } from 'formik';
import { omit, pick } from 'lodash/fp';
import { useMemo } from 'react';
import { type DealerWithPermissionsFragmentFragment } from '../../../../api/fragments/DealerWithPermissionsFragment';
import Form from '../../../../components/fields/Form';
import FormAutoTouch from '../../../../components/FormAutoTouch';
import useValidator from '../../../../utilities/useValidator';
import DealerUpdateForm from '../sections/DealerUpdateForm';
import dealerValidatorForm from '../useDealerValidators';
import useSubmit from './useSubmit';

export type DealerSettingFormProps = {
    dealer: DealerWithPermissionsFragmentFragment;
};

const DealerSettingForm = ({ dealer }: DealerSettingFormProps) => {
    const validators = useValidator(dealerValidatorForm);

    const initialValues = useMemo(
        () => ({
            dealerInput: {
                ...pick(
                    [
                        'displayName',
                        'isActive',
                        'legalName',
                        'coe',
                        'ppsr',
                        'estFee',
                        'disclaimers',
                        'integrationDetails',
                    ],
                    dealer
                ),
                contact: { ...omit('socialMedia', dealer.contact) },
            },
            socialMedia: dealer?.contact.socialMedia || [],
        }),
        [dealer]
    );

    const onSubmit = useSubmit(dealer);

    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit} validate={validators}>
            {({ handleSubmit }) => (
                <Form id="dealerForm-settings" name="addDealerForm" onSubmitCapture={handleSubmit}>
                    <FormAutoTouch />
                    <DealerUpdateForm dealer={dealer} />
                </Form>
            )}
        </Formik>
    );
};

export default DealerSettingForm;
